import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import AllWires from './all-wires';
import LatestWires from './latest-wires';
import MentionedWires from './mentioned-wires';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
`;

const TabbedContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #D7DFE7;
`;

const Tab = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 17px;
  line-height: 120%;
  font-weight: 700;
  text-transform: uppercase;
  color: ${props => props.theme.secondaryColor};
  padding: 0 10px 8px 10px;
  margin-right: 16px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }

  &.active {
    border-bottom: 2px solid ${props => props.theme.bodyColor};
    color: ${props => props.theme.bodyColor};

    &:hover {
      cursor: auto;
    }
  }
`;

const TabContent = styled.div`
  display: none;

  &.active {
    display: block;
  }
`;

export default function WiresContainer({
  profile,
  isScrollable,
  tab,
}) {
  const { id: contributorId, name: contributorName, slug } = profile;
  const [activeTab, setActiveTab] = React.useState(tab);
  const [tabChanged, setTabChanged] = React.useState(false);
  const tabCommonProps = { contributorId, contributorName };
  const tabs = {
    all: <AllWires {...tabCommonProps} isScrollable={!tabChanged && isScrollable && activeTab === 'all'} />,
    latest: <LatestWires {...tabCommonProps} isScrollable={!tabChanged && isScrollable && activeTab === 'latest'} />,
    mentions: <MentionedWires {...tabCommonProps} isScrollable={!tabChanged && isScrollable && activeTab === 'mentions'} />,
  };

  const handleOnClick = selectedTab => {
    setActiveTab(selectedTab);
    setTabChanged(true);
    window.history.pushState(null, document.title, `/search/contributor/${slug}?tab=${selectedTab}`);
  };

  return (
    <Container>
      <TabbedContainer>
        {_.keys(tabs).map(key => (
          <Tab key={key} className={activeTab === key ? 'active' : ''} onClick={() => handleOnClick(key)}>
            {key}
          </Tab>
        ))}
      </TabbedContainer>
      {_.keys(tabs).map(key => (
        <TabContent key={key} className={activeTab === key ? 'active' : ''}>
          {tabs[key]}
        </TabContent>
      ))}
    </Container>
  );
}

WiresContainer.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  tab: PropTypes.oneOf(['all', 'latest', 'mentions']).isRequired,
  isScrollable: PropTypes.bool,
};

WiresContainer.defaultProps = {
  isScrollable: false,
};
